import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import * as styles from './styles';


export default class Spinner extends React.PureComponent {

  // Dismissing is opt in: only callers that pass "onClose" get a spinner the user can
  // click away. Without it the spinner behaves as before and can only be closed by the
  // owner flipping "open" - which is what every list/form that waits on its own request
  // wants, since closing the spinner there would not cancel anything.
  handleClose = () => {
    if (typeof this.props.onClose === 'function') {
      this.props.onClose();
    }
  }

  render() {
    const dismissable = typeof this.props.onClose === 'function';
    // The backdrop click is handled by the Modal, but the paper itself is inside the
    // modal - clicking the white box (or the circle in it) has to be caught here.
    const paperStyle = dismissable ?
        { ...styles.modalPaper, cursor: "pointer" } :
        styles.modalPaper;

    return (
        <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        style={styles.modal}
        open={this.props.open}
        onClose={dismissable ? this.handleClose : undefined}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
            timeout: 500,
        }}
        >
        <Fade in={this.props.open}>
            <div style={paperStyle} onClick={dismissable ? this.handleClose : undefined}>
                <CircularProgress style={styles.progressCircle} />
            </div>
        </Fade>
        </Modal>
    )
  }

}
